module.exports = __webpack_public_path__ + "img/LB.3fa7b336.svg";